<template>
    <div
        v-if="portal === 'employee' && shadowStore.isShadowing"
        class="relative flex h-12 w-full items-center bg-ds-orange-400 text-center align-middle text-base text-white hover:text-white"
    >
        <span class="flex-1 font-inter font-normal">
            <span>
                You are currently shadowing<strong>{{
                    shadowStore.shadowAccountName ? ' ' + shadowStore.shadowAccountName : ''
                }}</strong
                >.
            </span>
            <span
                class="btn btn-link ml-1 underline hover:text-white"
                @click="shadowStore.stopShadowing"
            >
                Return to your account.
            </span>
        </span>
    </div>
</template>

<script setup lang="ts">
import type { ClosinglockHeaderProps } from '@/components/Navigation/ClosinglockHeader.vue';
import { useShadowAccountStore } from '@/stores/shared/shadow-account.store';

defineProps<{
    portal: ClosinglockHeaderProps['portal'];
}>();

const shadowStore = useShadowAccountStore();
</script>
